var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAsset(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.887,17.2C25.134,15.946,23.463,15,22,15h-5.625c-1.443,0-3.141,0.901-3.948,2.098l-1.137,1.686 C10.86,19.42,9.769,20,9,20H5c-1.654,0-3,1.346-3,3v2c0,1.654,1.346,3,3,3h1.184C6.598,29.161,7.698,30,9,30c1.654,0,3-1.346,3-3 s-1.346-3-3-3c-1.302,0-2.402,0.839-2.816,2H5c-0.552,0-1-0.448-1-1v-2c0-0.552,0.448-1,1-1h4c1.443,0,3.141-0.901,3.948-2.098 l1.137-1.686C14.515,17.58,15.606,17,16.375,17H22c0.75,0,1.785,0.586,2.172,1.229l0.941,1.57c0.036,0.06,0.071,0.132,0.107,0.2H15 c-0.553,0-1,0.447-1,1s0.447,1,1,1h10.885C25.955,22.363,26,22.711,26,23v4c0,0.553,0.447,1,1,1s1-0.447,1-1v-4 c0-1.277-0.515-3.135-1.172-4.229L25.887,17.2z M9,26c0.552,0,1,0.448,1,1s-0.448,1-1,1s-1-0.448-1-1S8.448,26,9,26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,24c-1.654,0-3,1.346-3,3s1.346,3,3,3s3-1.346,3-3S22.654,24,21,24z M21,28c-0.552,0-1-0.448-1-1s0.448-1,1-1 s1,0.448,1,1S21.552,28,21,28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,6H13V5c0-1.654-1.346-3-3-3H6C4.346,2,3,3.346,3,5v13c0,0.553,0.447,1,1,1s1-0.447,1-1V5c0-0.552,0.448-1,1-1h4 c0.552,0,1,0.448,1,1v9c0,0.553,0.447,1,1,1s1-0.447,1-1V8h13c0.552,0,1,0.448,1,1v6c0,0.553,0.447,1,1,1s1-0.447,1-1V9 C29,7.346,27.654,6,26,6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,11c0.553,0,1-0.447,1-1V8c0-0.553-0.447-1-1-1S7,7.447,7,8v2C7,10.553,7.447,11,8,11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,12c0.553,0,1-0.447,1-1s-0.447-1-1-1h-2c-0.553,0-1,0.447-1,1s0.447,1,1,1H18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,12c0.553,0,1-0.447,1-1s-0.447-1-1-1h-2c-0.553,0-1,0.447-1,1s0.447,1,1,1H24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,16c0,0.553,0.447,1,1,1s1-0.447,1-1v-2c0-0.553-0.447-1-1-1s-1,0.447-1,1V16z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset);
export default __webpack_public_path__ + "static/media/asset.a95c8b824700b3cf9615a9bc87b4f2d9.svg";
export { ForwardRef as ReactComponent };